"use client";

import { Flex, Loader } from "@vetty/ui";

import { useResendPhoneVerificationCode } from "./_hooks/useResendPhoneVerificationCode";

import styles from "./ResendPhoneVerificationCode.module.scss";

/**
 * ResendPhoneVerificationCode Component
 *
 * Lets the user request another SMS code after a cooldown.
 *
 * @returns Resend row with timer or action
 */
const ResendPhoneVerificationCode = () => {
  // Cooldown timer, button copy, and the send-code handler
  const { loading, timeout, text, handleResendCode } =
    useResendPhoneVerificationCode();

  return (
    <>
      {/* Prompt plus either the resend action or the remaining cooldown */}
      <Flex align={"center"} gap={5} className={styles["comp"]}>
        <span>Didn&apos;t get a code?</span>

        {timeout === 0 ? (
          <button onClick={handleResendCode}>
            <span>{text}</span>
            {/* Spinner while the SMS request is in flight */}
            {loading && <Loader size={16} borderWidth={2} />}
          </button>
        ) : (
          <div className={styles["comp__timer"]}>
            Resend in {Math.ceil(timeout / 1000)}s
          </div>
        )}
      </Flex>
    </>
  );
};

export { ResendPhoneVerificationCode };
